import {formatPercent} from '@deliveriesondemand/dod-utils';
import {formatMoney} from 'accounting';
import {Component, Fragment} from 'react';
import injectSheet from 'react-jss';

import NavigationService from '-/services/NavigationService';
import Button from '-/components/general/Button';

const styles = () => ({
    root: {
        textAlign: 'center',
        paddingLeft: 20,
        paddingRight: 20,

        '& h3': {
            fontSize: '1.25em',
            marginTop: 20,
            marginBottom: 20
        },

        '& p': {
            marginTop: 20,
            marginBottom: 20
        }
    },
    button: {
        '@media all and (max-width: 448px)': {
            fontSize: '.75em',
            letterSpacing: 1,
            margin: 0,
            fontWeight: 'normal'
        }
    },
    table: {
        textAlign: 'center',
        width: 400,
        margin: '0 auto'
    },
    highlight: {
        fontWeight: 'bold',
        fontStyle: 'italic'
    }
});

class GiftCardLongFormLanding extends Component {
    onNextClick = () => {
        NavigationService.next('buyerInfo');
    };

    render() {
        const {
            shortName,
            classes = {},
            creditor: {
                eligibleRates = []
            } = {},
            dealInfo: {
                recalculated: {
                    previouslyOfferedRate
                } = {},
                rateReduction,
                lifeTimeSavings,
                existingRate,
                newRate
            } = {},
            vehicleInfo: {
                year
            } = {}
        } = this.props;

        const letDown = newRate > previouslyOfferedRate;
        const showLifeTimeSavings = lifeTimeSavings >= 1000;
        const showRates = newRate < existingRate;

        let savings;

        if (showLifeTimeSavings) {
            savings = `save you ${formatMoney(lifeTimeSavings)}`;
        } else if (showRates) {
            savings = `lower your rate by ${formatPercent(rateReduction, 'dynamic')}`;
        } else {
            savings = 'save you some money on your car loan';
        }

        const formattedPreviousRate = formatPercent(previouslyOfferedRate, 'dynamic');

        return (
            <section className={classes.root}>
                <h1>Nice Work {shortName}!</h1>
                <h3>Want to earn another $10?</h3>
                <p><b>
                    We just need a few more pieces of information to {savings}
                </b></p>
                <p>
                    <Button
                        width={95}
                        className={classes.button}
                        tag="a"
                        href="#"
                        onClick={this.onNextClick}
                        role="button">
                        Save some Money!
                    </Button>
                </p>
                {letDown && (
                    <Fragment>
                        <h3>RATE CHANGE</h3>
                        <p>
                            It looks like we originally offered you a rate of {formattedPreviousRate}.
                            That rate has changed due to your vehicle&apos;s year ({year}).
                            Please see the table below for more information on how we
                            determine rates.
                        </p>
                        <table className={classes.table}>
                            <thead>
                                <tr>
                                    <td><b>Year Range</b></td>
                                    <td><b>Rate</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                {eligibleRates.map((eligibleRate, i) => {
                                    const {maxYear, minYear, rate} = eligibleRate;
                                    const offeredRate = year >= minYear && year <= maxYear;

                                    return (
                                        <tr className={offeredRate ? classes.highlight : ''} key={`rate-${i}`}>
                                            <td>{minYear} - {maxYear}</td>
                                            <td>{formatPercent(rate, 'dynamic')}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                    </Fragment>
                )}
            </section>
        );
    }
}

export default injectSheet(styles)(GiftCardLongFormLanding);
